import { gql } from '@apollo/client';

export interface IGetMoneyByTypeResponse {
  getWorkShiftPaymentOverviewData: {
    sum: {
      good: number;
      service: number;
      tariff: number;
      deposit: number;
    };
  } | null;
}
export interface IGetMoneyByTypeRequest {
  id?: number;
}
export const GET_MONEY_BY_TYPE = gql`
  query getMoneyByType($id: Int) {
    getWorkShiftPaymentOverviewData(id: $id) {
      sum {
        good
        service
        tariff
        deposit
      }
    }
  }
`;
